import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { glTFAsset } from "pixi3d/pixi7";
import { Texture, Spritesheet } from "pixi.js";
export class GameResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("GameResourcePackage");
    }
    public get assets_views_game_dice_AnimatedDices_gltf(): glTFAsset {
        return this.resource<glTFAsset>("assets/views/game/dice/AnimatedDices.gltf");
    }
    public get assets_views_game_staticBackground_png(): Texture {
        return this.resource<Texture>("assets/views/game/staticBackground.png");
    }
    public get assets_views_game_ui_ui_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/game/ui/ui_1x.atlas.json");
    }
    public get assets_views_game_ui_background_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["background.png"];
    }
    public get assets_views_game_ui_union_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["union.png"];
    }
    public get assets_views_game_ui_main_button_dice_button_bg_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["main_button/dice_button_bg.png"];
    }
    public get assets_views_game_ui_building_button_light_red_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["building_button/light_red.png"];
    }
    public get assets_views_game_ui_marketplace_button_light_white_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["marketplace_button/light_white.png"];
    }
    public get assets_views_game_ui_main_button_dice_button_icon_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["main_button/dice_button_icon.png"];
    }
    public get assets_views_game_ui_tournament_icon_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["tournament_icon.png"];
    }
    public get assets_views_game_ui_building_button_my_building_button_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["building_button/my_building_button.png"];
    }
    public get assets_views_game_ui_marketplace_button_news_button_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["marketplace_button/news_button.png"];
    }
    public get assets_views_game_ui_renters_button_renter_quest_icon_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["renters_button/renter_quest_icon.png"];
    }
    public get assets_views_game_ui_wheel_icon_gift_wheel_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["wheel_icon/gift_wheel.png"];
    }
    public get assets_views_game_ui_wheel_icon_gift_dices_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["wheel_icon/gift_dices.png"];
    }
    public get assets_views_game_ui_building_button_hard_hat_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["building_button/hard_hat.png"];
    }
    public get assets_views_game_ui_news_button_news_icon_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["news_button/news_icon.png"];
    }
    public get assets_views_game_ui_building_button_MB_icon_png(): Texture {
        return this.assets_views_game_ui_ui_1x_atlas_json.textures["building_button/MB_icon.png"];
    }
    public get assets_views_game_ui_ui_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/game/ui/ui_1x.atlas.png");
    }
}

